/* eslint-disable formatjs/no-literal-string-in-jsx */

import { Address as AddressType } from '@shared/types'
import { BodyText, LabelText } from '@ui-components/typography/Typography'
import { JSX } from 'react'
import { useIntl } from 'react-intl'

import { Address } from './Address'

export const NameAndAddressBase = (props: {
  firstNames?: string
  lastName?: string
  address: AddressType
  label?: string
}): JSX.Element => {
  const intl = useIntl()
  const { lastName, firstNames, label, address } = props
  const labelToUse = label ?? intl.formatMessage({ id: 'common-name-and-address' })

  return (
    <div data-testid="name-and-address-section">
      <LabelText tagName="div">{labelToUse}</LabelText>
      <BodyText tagName="p" data-testid="name-and-address">
        {`${firstNames} ${lastName}`}
        <br />
        <Address address={address} data-testid="address" />
      </BodyText>
    </div>
  )
}
